import { MapBoxStyleSpecService } from '../../../carried-over-from_1.10/mapbox-style-spec.service';
import {
  VectorStyleLayer,
  VectorStyle
} from '../../../layer-type-services/vector-tile/twc-vector-tile.layer';
import { TwcProduct } from '../../../twc-products';

const TWC_SURFACE_VECTOR_STYLE_LAYERS: VectorStyleLayer[] = [
  {
    layout: {},
    paint: {
      'line-width': 1.5,
      'line-color': '#858585'
    },
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'contour-line-1',
    filter: ['==', 'layer_name', 'CONTOUR_LINE'],
    type: 'line',
    maxzoom: 28
  },
  {
    layout: {
      'text-field': [
        'slice',
        MapBoxStyleSpecService.getAttributeFromCompositeObject('value'),
        0,
        [
          'index-of',
          '.',
          MapBoxStyleSpecService.getAttributeFromCompositeObject('value')
        ]
      ]
    },
    paint: {},
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'contour-line-2',
    filter: ['==', 'layer_name', 'CONTOUR_LINE'],
    type: 'symbol',
    maxzoom: 28
  },
  {
    layout: {},
    paint: {
      'line-width': 15,
      'line-pattern':
        MapBoxStyleSpecService.getAttributeFromCompositeObject('front_type'),
      'line-cap': 'round'
    },
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'front',
    filter: ['==', 'layer_name', 'FRONT'],
    type: 'line',
    maxzoom: 28
  },
  {
    layout: {
      'icon-image':
        MapBoxStyleSpecService.getAttributeFromCompositeObject('pc_type'),
      'icon-size': 1.6,
      'icon-allow-overlap': true,
      'text-field':
        MapBoxStyleSpecService.getAttributeFromCompositeObject('pressure_mb'),
      'text-offset': [0, 2.5],
      'text-size': 10
    },
    paint: {},
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'pressure-center',
    filter: ['==', 'layer_name', 'PRESSURE_CENTER'],
    type: 'symbol',
    maxzoom: 28
  }
];

export const TWC_SURFACE_VECTOR_STYLE: VectorStyle = {
  layers: TWC_SURFACE_VECTOR_STYLE_LAYERS,
  sprite: `assets/weather/sprites/Surface_Wx`,
  glyphs: `assets/weather/glyphs/Font11_Regular/0-255.pbf`
};

export const SURFACE_PRODUCT_DATA: TwcProduct = {
  id: 'surface-weather',
  defaultProductId: '1266',
  productName: 'Weather-Surface-Forecast-TWC',
  label: 'Surface Weather',
  weatherType: 'SURFACE_FORECAST',
  description: 'TWC product (vector) - Global Surface Forecasts',
  series: 'Forecast',
  timeSlicePeriodInMinutes: 360,
  lodMax: 5,
  protocol: 'VectorTile',
  forecastTimeSlicePeriod: 360,
  flightLevelProductIds: {},
  zOrder: 85,
  layerSpecs: { vectorTile: { vectorStyle: TWC_SURFACE_VECTOR_STYLE } }
};
